import { jsx as _jsx } from "react/jsx-runtime";
import { Typography } from '@mui/material';
import { useViewport } from '@xyflow/react';
export const SchematicLabel = ({ size, rotation, colour, stroke, text, context }) => {
    const { minFontSize, fontSizeScaleDivisor, maxFontSize, bold, upright } = context;
    const { zoom } = useViewport();
    const mapped = Math.sqrt(Math.max(zoom - 0.25, 0));
    const opacity = Math.max(0, Math.min(mapped, 1));
    return (_jsx(Typography, { position: "absolute", top: "50%", left: "50%", textAlign: "center", lineHeight: "100%", color: colour, fontSize: Math.max(minFontSize, Math.min(size / fontSizeScaleDivisor, maxFontSize)), fontWeight: bold ? '900' : undefined, sx: {
            translate: '-50% -50%',
            rotate: upright && rotation ? `-${rotation}rad` : undefined,
            opacity,
            /** this is necessary to fix macOS variable-font rendering bug: https://stackoverflow.com/a/69937834 */
            paintOrder: 'stroke fill',
            WebkitTextStrokeColor: stroke,
            WebkitTextStrokeWidth: '0.15em',
        }, children: text }));
};
